module.exports = wx;


//////////////////
// WEBPACK FOOTER
// external "wx"
// module id = ebTe
// module chunks = 1